// TOP LEVEL IMPORTS
import React from 'react';
import Button from 'antd/lib/button';
//
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

// CONSTANTS & DESTRUCTURING
// ===================================

const SubmitButton = ({ loading, amount, currencySymbol }) => {
  const buttonText = loading
    ? 'SUBMITTING...'
    : `PAY ${CurrencyHelpers.centsToDollars(amount, { symbol: currencySymbol })}`;

  return (
    <Button
      style={{ width: '100%', height: 43, marginTop: 15 }}
      type="primary"
      size="large"
      htmlType="submit"
      disabled={loading}
      loading={loading}
    >
      {buttonText}
    </Button>
  );
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/PaymentFormContainer/PaymentForm/SubmitButton/index.js